export interface BuildActorDescriptionOptions {
  /** The actor's category (e.g. "Bot", "Person"). */
  category?: string
  /** When true, the category (or `fallbackTypeLabel`) is included. */
  includeCategory: boolean
  /**
   * Humanized actor type label to use when `category` is not available
   * (typically because the categories metadata endpoint returned 404).
   */
  fallbackTypeLabel?: string
  /** Team `@handle` extra (e.g. for actors of type Team). */
  teamHandle?: string
  /** Integration owner extra (e.g. for actors of type Integration). */
  integrationOwner?: string
}

/**
 * Build the secondary description shown next to an actor's name.
 *
 * The category portion is included only when `includeCategory` is true (so
 * that, when the dropdown / list is already filtered to a single category,
 * the description doesn't repeat that category for every row). Per-actor
 * extras (team `@handle`, integration owner) are always appended when set.
 */
export function buildActorDescription(opts: BuildActorDescriptionOptions): string | undefined {
  const parts: string[] = []
  if (opts.includeCategory) {
    if (opts.category) {
      parts.push(opts.category)
    } else if (opts.fallbackTypeLabel) {
      parts.push(opts.fallbackTypeLabel)
    }
  }
  if (opts.teamHandle) {
    parts.push(`@${opts.teamHandle}`)
  } else if (opts.integrationOwner) {
    parts.push(opts.integrationOwner)
  }
  if (parts.length === 0) return undefined
  return parts.join(' • ')
}
